import styled from 'styled-components';

import {MaxWidthContainer} from 'components/ui-kit/MaxWidthContainer';
import {colors} from 'theme';

export const Wrapper = styled(MaxWidthContainer)`
    padding-top: 8px;
    background: ${colors.background};
    min-height: calc(100vh - 70px - 36px);
`;

export const FlexWrapper = styled(MaxWidthContainer)`
    padding-top: 8px;
    padding-bottom: 20px;
    background: ${colors.background};
    min-height: calc(100vh - 70px - 36px);
    display: flex;
    flex-direction: column;
`;
